import { TagType } from "@/types/tags.type";

class Tag {
  name: string = "";
  id?: string = "";
  created_at?: string = "";
  updated_at?: string = "";
  selected?: boolean = false;
  new?: boolean = false;

  public static MODULE_NAME = "customers/tag";

  constructor(data: TagType) {
    this.id = data.id;
    this.name = data.name;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.selected = data.selected || false;
    this.new = data.new || false;
  }

  public getTag(): Object {
    return {
      id: this.id,
      name: this.name,
      created_at: this.created_at,
      updated_at: this.updated_at,
      selected: this.selected,
      new: this.new,
    };
  }

  public toData(): Object {
    return {
      id: this.id,
      name: this.name,
      created_at: this.created_at,
      updated_at: this.updated_at,
      selected: this.selected,
      new: this.new,
    };
  }

  public toJson(): Object {
    return {
      id: this.id,
    };
  }
}

export default Tag;
